/**
 * Remove HTML tags with attributes in string
 *
 * @example removeHtmlTags('<div class="test"><p>test</p>')
 * return 'test'
 *
 * @param {string} string
 *
 * @return {string}
 */
export const removeHtmlTags = (string) => {
  if (string == null) return '';
  const regex = /(<([^>]+)>*)/gi;
  return String(string).replace(regex, '');
};
